<template>
    <div class="table-b">
        <div class="table-header">
            <div class="table-name">
                <h3 class="ico_table_name">방문기록 [<span style="color: #1e88cf">{{this.visitorNm}}</span>]</h3>
            </div>
        </div>
        <div class="grid-wrap">
            <dhx-grid ref="grid" v-model="visitorInfo" :config="configInfo"/>
        </div>
    </div>
</template>

<script>
    import mixin from '@/mixin';
    import mixinSlip from '@/mixin/slip';
    import _ from 'lodash'
    import DhxGrid from '@/components/DhxGrid.vue'

    export default {
        name: 'VisitorHistory',
        props: {
            'value': {
                type: Object,
                required: true
            },
            'visitorSeq' :{
                required: true
            },
            'visitorNm' :{
                required: true
            },
        },
        mixins: [mixin, mixinSlip],
        components: {DhxGrid},
        data() {
            return {
                configInfo : {
                    columns: [
                        {id: 'visitYmd',align: 'center',value: '방문일',width: 50},
                        {id: 'inTime',align: 'center',value: '입실시간',width: 100},
                        {id: 'outTime',align: 'center',value: '퇴실시간',width: 100},
                    ],
                    height: 240,
                    enablePaging: false,
                    afterRefreshData(grid, data) {
                        this.$nextTick(() => {
                            _.forEach(data, (item, index) => {
                            })
                        })
                    }
                },
                visitorInfo: [],
                today: this.$moment().format('YYYYMMDD'),
            };
        },
        methods: {
            saveExcel() {
                this.downloadExcel(this.$refs.grid);
            },
            getVisitorInfo(visitorSeq) {
                if(visitorSeq != '') {
                    this.$http.get(`/api/visit/visitorInfo`, {params: {visitNo: this.value.visitNo, visitorSeq: visitorSeq}})
                        .then(response => {
                            _.forEach(response.data, v => {
                                v.visitYmd = this.$moment(v.visitYmd).format('YYYY-MM-DD')
                                if (v.inTime) v.inTime = this.$moment(v.inTime).format('MM-DD / HH:mm')
                                if (v.outTime) v.outTime = this.$moment(v.outTime).format('MM-DD / HH:mm')
                                //if (v.outTime) v.outTime = this.$moment(v.outTime, 'YYYY-MM-DD HHmm').format('HH:mm')
                            })
                            this.visitorInfo = response.data;
                        })
                        .catch(({message}) => {
                            console.error(message);
                        })
                }
            },
        },
        mounted() {

        },
        watch: {
            visitorSeq: {
                immediate: true,
                deep: true,
                handler(value) {
                    this.getVisitorInfo(value);
                }
            },
        }
    };
</script>

<style scoped>
    .desc-content .item {
        float: left;
    }

    .desc-content .item .desc-item {
        position: relative;
        padding-left: 82px;
        margin-bottom: 8px;
    }

    .desc-content .item .desc-item:last-child {
        margin-bottom: 0;
        height: 25px;
    }

    .desc-content .item .desc-item .tit {
        position: absolute;
        left: 0;
    }

    .desc-content .item .desc-item .label-tit {
        font-family: 'NotoM';
        color: #222;
        font-size: 15px;
    }

    .desc-content .item.desc-left .desc-item {
        padding-left: 90px;
    }

    .desc-content .item.desc-left .desc-item .desc:after {
        clear: both;
        content: '';
        display: block;
    }

    .desc-content .item.desc-left .desc-item .desc .datepicker {
        float: left;
    }

    .desc-content .item.desc-left .desc-item .desc span.wave {
        float: left;
        padding: 0 6px;
    }

    .desc-content .item.desc-left .desc-item .td-s-thumb.search-area input,
    .desc-content .item.desc-left .desc-item .td-s-thumb.search-area .ip-box {
        float: left;
    }

    .desc-content .item.desc-left .desc-item .desc.select select {
        width: 70%;
    }

    .desc-content .item.desc-left {
        width: 35%;
        padding-right: 40px;
    }

    .desc-content .item.desc-center {
        width: 35%;
        padding-right: 40px;
    }

    .desc-content .item.desc-right {
        width: 30%;
    }

    .search-area input {
        position: relative;
    }

    .search-area .icon {
        position: absolute;
        right: 8px;
        top: 1px;
        z-index: 100;
        cursor: pointer;
        font-size: 16px;
        color: #555;
    }

    .search-border .td-s-thumb {
        position: relative;
        display: inline-block;
    }

    .search-border .td-s-thumb.search-area > input,
    .search-border .td-s-thumb.search-area > .ip-box
    .search-border .td-s-thumb.search-area > button {
        float: left;
    }

    .search-border .td-s-thumb.search-area .ip-box.ip-box-w02 {
        width: 60%;
        margin-left: 6px;
    }

    .search-border .td-s-thumb.search-area .ip-box {
        vertical-align: top;
    }

    @media (max-width: 1580px) {
        .search-border .td-s-thumb.search-area .ip-box.ip-box-w02 {
            width: 50%;
        }
    }
</style>

